export const integerRegEx = new RegExp('^-?\\d+$')
export const unsignedIntegerRegEx = new RegExp('^\\d+$')
export const floatRegEx = new RegExp('^-?\\d+(\\.\\d+)?$')
export const eosAccountNameRegEx = new RegExp(
    '(^[a-z1-5.]{1,11}[a-z1-5]$)|(^[a-z1-5.]{12}[a-j1-5]$)',
)
export const eosCollectiontNameRegEx = new RegExp('^[a-z1-5]{12}$')

export const linkClass = 'text-primary hover:text-neutral underline'
